export const CATALOG_KEYS = ["virales", "moda-mujer", "novedades"] as const;

export type CatalogKey = (typeof CATALOG_KEYS)[number];

export type CatalogDefinition = {
  key: CatalogKey;
  eyebrow: string;
  title: string;
  shortTitle: string;
  description: string;
  previewDescription: string;
  accent: string;
  softAccent: string;
  features: string[];
  previewLabels: string[];
  whatsappMessage: string;
};

export const CATALOGS: Record<CatalogKey, CatalogDefinition> = {
  virales: {
    key: "virales",
    eyebrow: "SELECCIÓN CONFIRMADA POR BJN",
    title: "Productos virales",
    shortTitle: "Virales",
    description: "Productos seleccionados manualmente por el equipo BJN para contenido y LIVE.",
    previewDescription: "Explora una selección confirmada por el equipo BJN.",
    accent: "#ff315f",
    softAccent: "#ffe3ea",
    features: ["Selección manual", "Versiones confirmadas", "Acceso directo con ShareLink"],
    previewLabels: ["Belleza en tendencia", "Hallazgo para el hogar", "Producto visual", "Oportunidad LIVE", "Compra de impulso", "Tendencia semanal"],
    whatsappMessage: "Hola BJN, vi la selección de Productos Virales.",
  },
  "moda-mujer": {
    key: "moda-mujer",
    eyebrow: "PRODUCTOS CON APROBACIÓN OFICIAL",
    title: "Moda con aprobación oficial",
    shortTitle: "Moda oficial",
    description: "Productos de moda incluidos en la lista oficial de aprobación de muestras de TikTok Shop.",
    previewDescription: "Descubre productos de moda administrados mediante la lista oficial vigente.",
    accent: "#7747ff",
    softAccent: "#eee8ff",
    features: ["Lista oficial vigente", "Búsqueda por tienda o PID", "Acceso directo con ShareLink"],
    previewLabels: ["Looks completos", "Tops y blusas", "Ropa deportiva", "Vestidos", "Pantalones", "Accesorios"],
    whatsappMessage: "Hola BJN, vi la selección de Moda para Mujer.",
  },
  novedades: {
    key: "novedades",
    eyebrow: "OPORTUNIDADES SELECCIONADAS PARA CRECER",
    title: "Oportunidades para crecer",
    shortTitle: "Para crecer",
    description: "Productos seleccionados manualmente por BJN para ampliar opciones de contenido y promoción.",
    previewDescription: "Una selección confirmada para creadoras y creadores que buscan más opciones de promoción.",
    accent: "#007f69",
    softAccent: "#ddf7ef",
    features: ["Selección manual", "Versiones confirmadas", "Acceso directo con ShareLink"],
    previewLabels: ["Nuevo lanzamiento", "Producto para probar", "Categoría emergente", "Idea de contenido", "Primera oportunidad", "Selección BJN"],
    whatsappMessage: "Hola BJN, vi la selección de Novedades con Potencial.",
  },
};

export function isCatalogKey(value: string | undefined): value is CatalogKey {
  return Boolean(value && CATALOG_KEYS.includes(value as CatalogKey));
}
